import {Col, Row, Image} from 'antd';
import React, {useEffect, useRef, useState, useLayoutEffect} from 'react';
import './index.css'
import {useSelector} from 'react-redux';
import CreateChatApp from '../../../comm/createChat'
import {getHistoryMessages, hyperChat} from "../../../api/other";
import AnalysisAnswer from './analysisAnswer'

const AnalysisApp = (props) => {
    const {sendTxt, setSendTxt, clearContent, setClearContent,setHomePageIndex,themeVlue,homePageIndex} = props
    const {size} = useSelector(state => state.fontSizeChange)
    const [pageList, setPageList] = useState([])
    const {userInfo, allContextMeta, rememberSvg} = useSelector(state => state.user)
    var analysis_meta = null;
    if (userInfo && allContextMeta) {
        analysis_meta = allContextMeta.analysis_meta
    }
    const sizeStyle = {
        fontSize: size === '小' ? '15px' : (size === '中' ? '18px' : '22px')
    }
    const [svgIndex, setSvgIndex] = useState([])
    const [viewType,setViewType] = useState('instant')
    useEffect(() => {
        if (sendTxt) {
            let list = pageList
            list.push({
                user_content: sendTxt.user_content,
                responder_content: []
            })
            setViewType('smooth')
            setPageList([...list])
            hyperChat(sendTxt).then(res => {
                setSendTxt(null)
                if (res) {
                    list[list.length - 1]['responder_content'] = res
                } else {
                    list[list.length - 1]['responder_content'] = null
                }
                setPageList([...list])
                setSvgIndex([...svgIndex, 0])
            })
        }
    }, [sendTxt])
    useEffect(() => {
        handleScrollContainer()
    }, [pageList])
    var isReload = false
    useEffect(() => {
        if (!isReload && clearContent) {
            isReload = true
            if(analysis_meta) getHisList()
            setTimeout(() => {
                isReload = false
                setClearContent(false)
            }, 1000)
        }
    }, [clearContent])
    useEffect(() => {
        if (!isReload) {
            isReload = true
            if(analysis_meta) getHisList()
            setTimeout(() => {
                isReload = false
            }, 1000)
        }
    }, [homePageIndex])
    const handleScrollContainer = () => {
        chatEndRef.current?.scrollIntoView({behavior: viewType})
    }
    //获取历史记录
    const getHisList = (n) => {
        getHistoryMessages({context_id: analysis_meta?.context_id}).then(res => {
            if (res.code === 200) {
                setViewType('instant')
                let index = []
                res.data.map(info => {
                    index.push(0)
                })
                setSvgIndex([...index])
                setPageList(res.data)
            }
        })
    }
    //是否显示语标
    useLayoutEffect(() => {
        if (rememberSvg === 'hidden') {
            hiddenLightIpa()
        } else {
            showLightIpa()
        }
    }, [rememberSvg])
    //更新analysis_meta
    // useEffect(() => {
    //     analysis_meta = allContextMeta.analysis_meta
    // }, [allContextMeta])
    const chatEndRef = useRef(null);
    const [classNameToGBW, setClassNameToGBW] = useState()
    const hiddenLightIpa = () => {
        setClassNameToGBW('hide-gbw-li')
    }
    const showLightIpa = () => {
        setClassNameToGBW('show-gbw-li')
    }
    const getAnswerSvg = (list, i) => {
        //    gbw_svg_en_ls   gbw_svg_zh_ls
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        return svgList[index[i]].toString()
    }
    const handleSvgNext = (list, i) => {
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        if (index[i] >= (svgList.length - 1)) {
            index[i] = 0
            setSvgIndex([...index])
            return svgList[0].toString()
        }
        index[i] = index[i] + 1
        setSvgIndex([...index])
        return svgList[index[i]].toString()
    }
    const handleSvgPrev = (list, i) => {
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        if (index[i] === 0) {
            index[i] = (svgList.length - 1)
            setSvgIndex([...index])
            return svgList[index[i]].toString()
        }
        index[i] = index[i] - 1
        setSvgIndex([...index])
        return svgList[index[i]].toString()
    }
    return (
        <div className={`bg-a ${classNameToGBW}`}>
            <div className={`bgWrap-a ${themeVlue==='default'?'':'drak'}`} id={'scrollable-element'}>
                {
                    pageList && pageList.length > 0 ?
                        pageList.map((res, i) => {
                            return (
                                <div>
                                    {res?.user_content ?
                                        <div className="question" key={'ques-q' + i}>
                                            <Row>
                                                <Col span={2}> </Col>
                                                <Col span={20} className="questionInfo" style={sizeStyle}>
                                                    <span style={{
                                                        whiteSpace: 'pre-wrap',
                                                        wordWrap: 'break-word'
                                                    }}>{res.user_content[0].text}</span>
                                                </Col>
                                                <Col className='headPortrait' span={2}>
                                                    <Image preview={false} src={userInfo?.avatar} width={35}/>
                                                </Col>
                                            </Row>
                                        </div> : ''}
                                    {
                                        res?.responder_content && res?.responder_content.length > 0 ?
                                            <div className="answer" key={'answer-a' + i}>
                                                <Row>
                                                    <Col span={2} className="answerHeadPortrait">
                                                        <Image preview={false}
                                                               src={analysis_meta.responder_avatar?analysis_meta.responder_avatar:require('../../../assets/comm/ai-chat-logo.png')}
                                                               width={35} height={35} style={{borderRadius:'50%'}}/>
                                                    </Col>
                                                    <Col span={20}>
                                                        <AnalysisAnswer answer={res} analysisMeta={analysis_meta} ti={i} setSvgIndex={setSvgIndex} svgIndex={svgIndex} />
                                                    </Col>
                                                    <Col span={2}> </Col>
                                                </Row>
                                            </div> : <div className="answer" key={'answer-b' + i}>
                                                <Row>
                                                    <Col span={2} className="answerHeadPortrait">
                                                        <Image preview={false}
                                                               src={analysis_meta.responder_avatar?analysis_meta.responder_avatar:require('../../../assets/comm/ai-chat-logo.png')}
                                                               width={35} height={35} style={{borderRadius:'50%'}}/>
                                                    </Col>
                                                    <Col span={20}>
                                                        <div style={{paddingTop: '8px'}}>
                                                            分析失败
                                                        </div>
                                                    </Col>
                                                    <Col span={2}> </Col>
                                                </Row>

                                            </div>
                                    }
                                    <CreateChatApp addParam={res} originalScenario={'analysis'} setHomePageIndex={setHomePageIndex}/>
                                </div>
                            )
                        })
                        : ''
                }
                <div ref={chatEndRef}/>
            </div>

        </div>
    )
};
export default AnalysisApp;



